import { fromRetentionResult, toRetentionQuery } from './retentionConverter';
import {
  getGlobalFilter,
  getProjectZoneId,
  getRetentionComplexCustomSequence,
  getRetentionComplexDimensionType,
  getRetentionComplexFirstEvent,
  getRetentionComplexFirstEventFilter,
  getRetentionComplexReturnEvent,
  getRetentionComplexReturnEventFilter,
  getRetentionComplexUseLatestProfile,
  getRetentionDimensionType,
  getRetentionFirstEvent,
  getRetentionReturnEvent,
} from '../reducers/analyticsApp';
import { toFilter } from './filterConverter';
import { dimensionSequences } from '../constants/retention';
import { toCsvRetention } from './csv/csvConverter';

const createQuery = (state) => {
  const dimensionType = getRetentionDimensionType(state);
  return {
    timezone: getProjectZoneId(state),
    firstEvent: getRetentionFirstEvent(state),
    returnEvent: getRetentionReturnEvent(state),
    globalFilter: toFilter(getGlobalFilter(state)),
    sequence: {
      units: dimensionSequences[dimensionType],
      type: dimensionType,
    },
  };
};

const createDashboardQuery = (state, unit) => {
  const { dimensionType } = unit.compose.retention;

  return {
    timezone: getProjectZoneId(state),
    firstEvent: unit.compose.retention.firstEvent,
    returnEvent: unit.compose.retention.returnEvent,
    globalFilter: toFilter(getGlobalFilter(state)),
    sequence: {
      units: dimensionSequences[dimensionType],
      type: dimensionType,
    },
  };
};

export const createComplexQuery = (state) => {
  const dimensionType = getRetentionComplexDimensionType(state);
  return {
    timezone: getProjectZoneId(state),
    firstEvent: getRetentionComplexFirstEvent(state),
    returnEvent: getRetentionComplexReturnEvent(state),
    globalFilter: toFilter(getGlobalFilter(state)),
    firstEventFilter: toFilter(getRetentionComplexFirstEventFilter(state)),
    returnEventFilter: toFilter(getRetentionComplexReturnEventFilter(state)),
    sequence: {
      units: getRetentionComplexCustomSequence(state) || dimensionSequences[dimensionType],
      type: dimensionType,
    },
    useLastProfile: getRetentionComplexUseLatestProfile(state),
  };
};

export const createDashboardRetentionQuery = (state, unit) => {
  const { dimensionType } = unit.compose.retentionComplex;

  return {
    timezone: getProjectZoneId(state),
    firstEvent: unit.compose.retentionComplex.firstEvent,
    returnEvent: unit.compose.retentionComplex.returnEvent,
    globalFilter: toFilter(getGlobalFilter(state)),
    firstEventFilter: toFilter(unit.compose.retentionComplex.filters[0]),
    returnEventFilter: toFilter(unit.compose.retentionComplex.filters[1]),
    sequence: {
      units: unit.compose.retentionComplex.customSequence || dimensionSequences[dimensionType],
      type: dimensionType,
    },
    useLastProfile: unit.compose.retentionComplex.useLatestProfile,
  };
};

export const buildRetentionQuery = (state) => toRetentionQuery(createQuery(state));

export const buildRetentionDashboardQuery = (state, unit) =>
  toRetentionQuery(createDashboardQuery(state, unit));

export const buildRetentionComplexQuery = (state) => toRetentionQuery(createComplexQuery(state));

export const buildRetentionComplexDashboardQuery = (state, unit) =>
  toRetentionQuery(createDashboardRetentionQuery(state, unit));

export const getRetentionInfo = (state) => {
  const timezone = getProjectZoneId(state);

  return { timezone };
};

export const fromRetentionCsvResponse = (response, query, retentionInfo) => {
  const { timezone } = retentionInfo;
  const result = fromRetentionResult(response);

  return toCsvRetention(result, query, timezone);
};
